import datePickerReducer from './datePicker.slice'

export default datePickerReducer
